import { useCallback, useMemo, useState } from "react";
import { UserProfileMissingField } from "../components/web/propertyDetail/v2Components/PDAskUserMissingDetailsModal";
import { useGetProfileDetails } from "./useGetProfileDetails";
import { BidInterestRequestType } from "./useBidInterestApi";

export function useMissingUserDetailsControls() {
  const [missingFields, setMissingFields] = useState<UserProfileMissingField[]>(
    [],
  );
  const [openMissingDetailsModal, setOpenMissingDetailsModal] = useState(false);
  const [missingDetails, setMissingDetails] = useState({
    mobile: "",
  });

  const [
    askUserDetailsModalInitiatedFrom,
    setAskUserMissingDetailsModalInitiatedFrom,
  ] = useState<BidInterestRequestType>("na");

  const { name, email, mobile } = useGetProfileDetails();

  const handleOpenCollectMissingDetailsPopup = useCallback(
    (initiatedFrom: BidInterestRequestType): boolean => {
      const fields: UserProfileMissingField[] = [];

      if (!mobile) fields.push("mobile");

      if (fields.length === 0) return false;

      setMissingFields(fields);
      setAskUserMissingDetailsModalInitiatedFrom(initiatedFrom);
      setOpenMissingDetailsModal(true);
      return true;
    },
    [mobile],
  );

  const resolvedName = name;
  const resolvedEmail = email;
  const resolvedMobile = useMemo(
    () => mobile || missingDetails?.mobile,
    [missingDetails?.mobile, mobile],
  );

  return {
    missingFields,
    openMissingDetailsModal,
    setOpenMissingDetailsModal,
    askUserDetailsModalInitiatedFrom,
    setAskUserMissingDetailsModalInitiatedFrom,
    handleOpenCollectMissingDetailsPopup,
    missingDetails,
    setMissingDetails,
    resolvedName,
    resolvedEmail,
    resolvedMobile,
  };
}
